import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-utils");
import { keyframes } from '@vanilla-extract/css';
import { tokens } from '@paypalcorp/pp-react-theme';
import { style as _style } from '@vanilla-extract/css';
function style(rule, debugId) {
  return [_style(rule, debugId), rule];
}
export const variables = {
  ppuiEaseInOut: `cubic-bezier(${tokens.motion.timing.x1},${tokens.motion.timing.y1}, ${tokens.motion.timing.x2},${tokens.motion.timing.y2})`,
  ppuiEaseLoopStandard: `cubic-bezier(${tokens.motion.easing.loop.standard})`,
  ppuiEaseEnterSmall: `cubic-bezier(${tokens.motion.easing.enter.small})`,
  ppuiEaseExitSmall: `cubic-bezier(${tokens.motion.easing.exit.small})`,
  ppuiEaseMoveSmall: `cubic-bezier(${tokens.motion.easing.move.small})`
};
export const [animationTimingName, animationTimingStyle] = style({
  animationTimingFunction: variables.ppuiEaseInOut
}, 'motion_animation');
export const [transitionTimingName, transitionTimingStyle] = style({
  transitionTimingFunction: variables.ppuiEaseInOut
}, 'motion_transition');
export const [ellipsisName, ellipsisStyles] = style({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
}, 'ellipsis');
export const slideRight = keyframes({
  '0%': {
    transform: `translateX(-100%)`
  },
  '100%': {
    transform: `translateX(0)`
  }
}, 'slide_right');
export const slideLeft = keyframes({
  '0%': {
    transform: `translateX(100%)`
  },
  '100%': {
    transform: `translateX(0)`
  }
}, 'slide_left');
__vanilla_filescope__.endFileScope();
